interface Listener {
  callback: Function;
  once: boolean;
}

interface EmitterEvents {
  [key: string]: Listener[];
}

export default class EventEmitter {
  public events: EmitterEvents;
  constructor(events?: EmitterEvents) {
    this.events = events || {};
  }

  public on = <T extends string>(event: T, callback: Function | Function[], once = false) => {
    log.emitter("Registering event", event);
    const callbacks = Array.isArray(callback) ? callback : [callback];
    this.events[event] = this.events[event] || [];
    this.events[event].push(...callbacks.map((cb) => ({ callback: cb, once })));

    return () => callbacks.forEach((cb) => this.off(event, cb));
  };

  public emit = <T extends string>(event: T, ...args: any[]) => {
    const listeners = this.events[event];
    if (!listeners) return;
    // if(this.events[event].length > 0) log.emitter("Emitting event", event);
    this.events[event] = listeners.filter((listener) => !listener.once);
    listeners.forEach((listener) => listener.callback(...args));
  };

  public off = <T extends string>(event: T, callback: Function) => {
    if (!this.events[event]) return;
    log.emitter("Unsubscribing from event", event);
    this.events[event] = this.events[event].filter((listener) => listener.callback !== callback);
  };

  public clear = () => {
    this.events = {};
  };
}
